export const iconFontAwesomeSpinnersDharmachakra = (
	<i className="fa-solid fa-dharmachakra"></i>
);
